import { getNestedRoute } from './getNestedRoute';
import { isTabRoute } from './isTabRoute';

import { PREV_PATH_LOCAL_STORAGE_KEY } from '../../config/routes';

export const saveCurrentTabRouteToLocalStorage = () => {
  if (isTabRoute(window.location.pathname)) {
    localStorage.setItem(PREV_PATH_LOCAL_STORAGE_KEY, getNestedRoute(window.location.pathname));
  }
};
